<div class="uk-grid" *ngIf="interStaticData">
  <div class="uk-width-1-3">
    <div class="uk-card uk-card-default" style="margin: 0 1rem 1rem 0" *ngIf="cardVisulisation.produit_encadre">
      <div class="uk-card-header uk-padding-small" [ngClass]="[headerBackground]">
        <div class="uk-grid-small uk-flex-middle uk-grid">
          <div class="uk-width-expand uk-width-5-6">
            <h3 class="uk-card-title uk-margin-remove-bottom primary-color " [ngClass]="[headerColor]">
              Produits encadrés
            </h3>
          </div>
          <div class="info primary-color uk-width-1-6 k-text-right">
            <i
              class="k-icon k-i-info"
              uk-tooltip="Il s’agit du nombre de produits que l’intervenant est habilité à encadrer.<br>
            Notez que cet indicateur est indépendant des filtres appliqués.<br>
            Masquez/affichez cet indicateur sur l’extranet de l’intervenant à l’aide du switch situé en haut à droite de la tuile."
            ></i>
          </div>
        </div>
      </div>
      <div class="uk-card-body uk-padding-small">
        <p>
          <span class="stats-number-before">{{
            interStaticData.produitsEncadres[0].nb_produits || 0 | number: '0.0':'fr'
          }}</span>
        </p>
        <br />
      </div>
    </div>

    <div class="uk-card uk-card-default" style="margin: 0 1rem 1rem 0" *ngIf="cardVisulisation.deplacement">
      <div class="uk-card-header uk-padding-small" [ngClass]="[headerBackground]">
        <div class="uk-grid-small uk-flex-middle uk-grid">
          <div class="uk-width-expand uk-width-5-6">
            <h3 class="uk-card-title uk-margin-remove-bottom primary-color " [ngClass]="[headerColor]">
              Déplacements
            </h3>
          </div>
          <div class="info primary-color uk-width-1-6 k-text-right">
            <i
              class="k-icon k-i-info"
              uk-tooltip="Il s’agit de données propres aux déplacements effectués en fonction des filtres appliqués.<br>
          Notez que le statut des sessions évoluant dans le temps, les données peuvent varier en fonction du moment de la consultation de l’indicateur.<br>
          Masquez/affichez cet indicateur sur l’extranet de l’intervenant à l’aide du switch situé en haut à droite de la tuile."
            ></i>
          </div>
        </div>
      </div>
      <div class="uk-card-body uk-padding-small">
        <p class="stats-sub-title margin-left-12 ">Distance parcourue</p>
        <p class="margin-left-12" *ngIf="interStaticData.trajetInterv[0]">
          <span class="stats-number-before">{{
            interStaticData.trajetInterv[0].distance_totale | number: '0.0':'fr'
          }}</span
          ><span class="stats-number-after"> km</span>
        </p>

        <p class="margin-left-12" *ngIf="!interStaticData.trajetInterv[0]">
          <span class="stats-number-before">0</span><span class="stats-number-after"> km</span>
        </p>

        <p class="stats-sub-title margin-left-12" *ngIf="interStaticData.trajetInterv[0]">Temps de trajet</p>
        <p class="margin-left-12" *ngIf="interStaticData.trajetInterv[0]">
          <span class="stats-number-before">{{
            getHeures(interStaticData.trajetInterv[0].temps_de_trajet) | number: '0.0':'fr'
          }}</span
          ><span class="stats-number-after">
            {{ getHeures(interStaticData.trajetInterv[0].temps_de_trajet) > 1 ? 'heures' : 'heure' }} </span
          ><span class="stats-number-before">{{
            getMinutes(interStaticData.trajetInterv[0].temps_de_trajet) | number: '0.0':'fr'
          }}</span
          ><span class="stats-number-after"> min</span>
        </p>
      </div>
    </div>
  </div>
  <div class="uk-width-1-3">
    <div class="uk-card uk-card-default" style="margin: 0 1rem 1rem 0" *ngIf="cardVisulisation.cout_intervenant">
      <div class="uk-card-header uk-padding-small" [ngClass]="[headerBackground]">
        <div class="uk-grid-small uk-flex-middle uk-grid">
          <div class="uk-width-expand uk-width-5-6">
            <h3 class="uk-card-title uk-margin-remove-bottom primary-color " [ngClass]="[headerColor]">
              Coût intervenant
            </h3>
          </div>
          <div class="info primary-color uk-width-1-6 k-text-right">
            <i
              class="k-icon k-i-info"
              uk-tooltip="Il s’agit du coût engendré par l’intervenant en fonction des filtres appliqués.<br>
                        Notez que le statut des sessions évoluant dans le temps, les données peuvent varier en fonction du moment de la consultation de l’indicateur. Notez également que les données sont calculées au prorata des dates de formation incluses dans la période filtrée.
"
            ></i>
          </div>
        </div>
      </div>
      <div class="uk-card-body uk-padding-small">
        <p class="stats-sub-title margin-left-12">Total</p>
        <p class="margin-left-12">
          <span class="stats-number-before">{{ interStaticData.coutTotalInterv }}</span
          ><span class="stats-number-after"> € HT</span>
        </p>
        <p class="stats-sub-title margin-left-12">Détails des coûts</p>
        <table class="bordered">
          <tbody>
            <tr class="border-table">
              <td class="padding-8 k-text-left">Coût pédagogique</td>
              <td class="padding-8 k-text-left">
                {{ (interStaticData.infoCoutTotalInterv[0] || {}).cout_pedagogique || 0 | number: '0.0':'fr' }}
                {{ indicator ? '€ NET' : '€ HT' }}
              </td>
              <td class="padding-8 k-text-left">
                {{ (interStaticData.infoCoutTotalInterv[0] || {}).cout_pedagogique || 0 | number: '0.0':'fr' }}
                {{ indicator ? '€ NET' : '€ HT' }}
              </td>
            </tr>
            <tr>
              <td class="padding-8 k-text-left">Déplacement</td>
              <td class="padding-8 k-text-left">
                {{ (interStaticData.infoCoutTotalInterv[0] || {}).cout_deplacement || 0 | number: '0.0':'fr' }}
                {{ indicator ? '€ NET' : '€ HT' }}
              </td>
            </tr>
            <tr class="border-table">
              <td class="padding-8 k-text-left">Hébergement</td>
              <td>
                {{ (interStaticData.infoCoutTotalInterv[0] || {}).cout_hotel || 0 | number: '0.0':'fr' }}
                {{ indicator ? '€ NET' : '€ HT' }}
              </td>
            </tr>
            <tr class="border-table">
              <td class="padding-8 k-text-left">Restauration</td>
              <td class="padding-8 k-text-left">
                {{ (interStaticData.infoCoutTotalInterv[0] || {}).cout_repas || 0 | number: '0.0':'fr' }}
                {{ indicator ? '€ NET' : '€ HT' }}
              </td>
            </tr>
            <tr class="border-table">
              <td class="padding-8 k-text-left">Matériel</td>
              <td class="padding-8 k-text-left">
                {{ (interStaticData.infoCoutTotalInterv[0] || {}).cout_materiel || 0 | number: '0.0':'fr' }}
                {{ indicator ? '€ NET' : '€ HT' }}
              </td>
            </tr>
          </tbody>
        </table>

        <p class="card-content" *ngIf="interStaticData.indispoInterv.length === 0">
          <span class="no-data">Donnée indisponible</span>
        </p>
        <br />
      </div>
    </div>
  </div>
  <div class="uk-width-1-3">
    <div class="uk-card uk-card-default" style="margin: 0 1rem 1rem 0" *ngIf="cardVisulisation.indisponibilite">
      <div class="uk-card-header uk-padding-small" [ngClass]="[headerBackground]">
        <div class="uk-grid-small uk-flex-middle uk-grid">
          <div class="uk-width-expand uk-width-5-6">
            <h3 class="uk-card-title uk-margin-remove-bottom primary-color " [ngClass]="[headerColor]">
              Indisponibilités
            </h3>
          </div>
          <div class="info primary-color uk-width-1-6 k-text-right">
            <i
              class="k-icon k-i-info"
              uk-tooltip="Il s’agit des indisponibilités répertoriées sur la période sélectionnée.<br>
          Notez que seul le filtre de période s’applique à cet indicateur.<br>
          Masquez/affichez cet indicateur sur l’extranet de l’intervenant à l’aide du switch situé en haut à droite de la tuile."
            ></i>
          </div>
        </div>
      </div>
      <div class="uk-card-body uk-padding-small">
        <p class="stats-sub-title margin-left-12">Nombre</p>
        <p class="margin-left-12">
          <span class="stats-number-before">{{ getDureeTotalIndispo(interStaticData.indispoInterv) }}</span>
        </p>
        <p class="stats-sub-title margin-left-12">Motif</p>
        <table class="bordered">
          <tbody>
            <tr class="border-table" *ngFor="let ligne of interStaticData.indispoInterv">
              <td class="padding-8 k-text-left">{{ ligne.libelle }}</td>
              <td class="padding-8 k-text-left">{{ getDureeIndispo(ligne.date_debut, ligne.date_fin) }}</td>
              <hr />
            </tr>
          </tbody>
        </table>
        <p class="card-content margin-left-12" *ngIf="interStaticData.indispoInterv.length === 0">
          <span class="no-data">Donnée indisponible</span>
        </p>
        <br />
      </div>
    </div>
  </div>
</div>
